import {XIcon} from "lucide-react";
import {type ReactNode} from "react";

import {useChatContext} from "@contexts/ChatContext";

interface ContentAreaProps {
    children: ReactNode;
}

export function ContentArea({children}: ContentAreaProps) {
    const {contentFullscreen, setContentFullscreen} = useChatContext();

    if (contentFullscreen) {
        return (
            <div className="fixed inset-0 bg-[#F8FAFC] z-40 overflow-y-auto p-6 md:px-8">
                <button
                    onClick={() => setContentFullscreen(false)}
                    className="fixed top-4 right-4 z-[41] w-9 h-9 rounded-lg border border-[#E2E8F0] bg-white text-[#0F172A] hover:border-[#209DB3] hover:text-[#209DB3] flex items-center justify-center shadow-md cursor-pointer"
                >
                    <XIcon className="size-4" />
                </button>
                {children}
            </div>
        );
    }

    return (
        <div className="flex-1 overflow-y-auto">
            {children}
        </div>
    );
}
